module.exports = __webpack_public_path__ + "img/delete.e64e2d9c.svg";